import { TransactionListService } from "../_services/api/templates/transactions-list.services";
import { CacheService } from "../_services/cache/cache-service";

export const reportPdfPreview = {
  namespaced: true,
  state: {
    reportPreviewScreens: undefined,
  },
  actions: {
    async setReportPreviewScreens({ commit }) {
      var previewScreens = CacheService.getCache("ReportPreviewScreens");

      if (!previewScreens)
        await TransactionListService.getReportPreviewScreens().then((previewReport) => {

          CacheService.saveCache("ReportPreviewScreens", previewReport.data.value, 5);
          commit("setReportPreviewScreens", previewReport.data.value);
        });
      else {
        commit("setReportPreviewScreens", previewScreens);
      }

    },
  },
  mutations: {
    setReportPreviewScreens(state, previewReport) {
      state.reportPreviewScreens = previewReport;
    },
  },
  getters: {
    getReportPreviewScreens(state) {
      if (!state.reportPreviewScreens) {
        var previewScreens = CacheService.getCache("ReportPreviewScreens");
        if (previewScreens) {
          return previewScreens;
        } else return undefined;
      } else
        return state.reportPreviewScreens;
    },
  },
};
